import React from 'react'
import Layout from '../../layout'

function Members() {
  return (
    <>
        <Layout props='members'></Layout>
    </>
  )
}

export default Members